var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 9.62516V9.16678C17.4167 5.70986 17.4166 3.98135 16.3427 2.90741C15.2687 1.8335 13.5403 1.8335 10.0833 1.8335C6.62649 1.8335 4.89799 1.83355 3.82406 2.90745C2.75014 3.98138 2.75013 5.70982 2.7501 9.16672L2.75006 13.2918C2.75003 16.3053 2.75002 17.8121 3.58228 18.8262C3.73467 19.0119 3.90493 19.1821 4.09062 19.3346C5.10477 20.1668 6.61151 20.1668 9.62501 20.1668",
    stroke: "#171615",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41667 6.4165H13.75M6.41667 10.0832H10.0833",
    stroke: "#171615",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.9582L15.125 16.454V14.2082M11 16.0415C11 18.3197 12.8468 20.1665 15.125 20.1665C17.4032 20.1665 19.25 18.3197 19.25 16.0415C19.25 13.7633 17.4032 11.9165 15.125 11.9165C12.8468 11.9165 11 13.7633 11 16.0415Z",
    stroke: "#171615",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.9f1dbcbc725b6688f4200bad56153e81.svg";
export { ForwardRef as ReactComponent };